module.exports = __webpack_public_path__ + "media/images/social/vv_03-3e256d0c787cb2d98ab1496db013c929.jpg";